import { useMemo } from "react"
import { useNameColumn } from "../../../../../../Team/Table/useColumns/useNameColumn";
import { useEmployeeNumberColumn } from "../../../../../../Team/Table/useColumns/useEmployeeNumberColumn";
import { useEarningGroupsColumns } from "../../../../../Table/useColumns/useEarningGroupsColumns";
import { usePaymentColumn } from "../../../../../Table/useColumns/usePaymentColumn";
import { usePayGroupColumn } from "../../../../../Table/useColumns/usePayGroupColumn";

export const useColumns = ({ canViewRates }) => {
    const nameColumn = useNameColumn({})
    const employeeNumberColumn = useEmployeeNumberColumn()
    const payGroupColumn = usePayGroupColumn()
    const earningGroupsColumns = useEarningGroupsColumns({ canViewRates });
    const paymentColumn = usePaymentColumn()

    return useMemo(() => {
        const columns = [
            nameColumn,
            employeeNumberColumn,
            payGroupColumn,
            ...earningGroupsColumns,
        ];

        if (canViewRates) {
            columns.push(paymentColumn);
        }

        return columns;
    }, [
        nameColumn,
        employeeNumberColumn,
        payGroupColumn,
        earningGroupsColumns,
        paymentColumn,
        canViewRates,
    ]);
}

